import React, { useState,useEffect } from 'react';
import './shipmentPolicyPage.css';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import { useUser } from '../../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/cartContext';


const ShipmentPolicyPage = () => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
    useUser();
    const { fetchCartQuantity,cartQuantity,setCartQuantity ,handleQuantity} = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId ,fetchCsrfToken} = useUser();
    useEffect(() => {
      fetchSeoMetaDetails()
      sessionStorage.removeItem("requestData");
      sessionStorage.removeItem("categoryType");
      sessionStorage.removeItem('categoryId');
      sessionStorage.removeItem('productId');
    
    }, []);
    useEffect(() => {
      const isSessionHandled = sessionStorage.getItem("sessionHandled");
    
      // If the session was already handled, avoid running this logic again
      if (isSessionHandled) return;
    
      // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
    
      if (checkSessionTokenExpirationStatus()) {
        // Clear session-related operations
        handleQuantity();
        handleRemoveLocalStorage();
    
        // Set the sessionHandled flag to true to prevent re-execution after reload
        sessionStorage.setItem("sessionHandled", "true");
    
        // Redirect to the homepage
        navigate("/");
    
        // Reload the page to clear cache
        window.location.reload();
      }
    }, []);

    const fetchSeoMetaDetails = async () => {
      try {
          const code = 'shipment_policy_page'
          const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
            {  method: 'GET',
              headers:{
                // Accept:'aplication/json',
                "Content-Type": "application/json"
        
              },
              credentials: "include",
              mode:"cors"                       
            }
          );
          if (!response.ok) throw new Error('Failed to fetch categories');
          const data = await response.json();
          await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
      } catch (error) {
          //console.error('Error fetching categories:', error);
      }
    };
    
    const changeTitleAndMetaTags = async (
      title: string,
      metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
    ) => {
      try {
          // Update the document title
          if (title) {
              document.title = title;
          } else {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
          }
    
          // Update or create meta tags
          Object.keys(metaTags).forEach((metaName) => {
              const metaTag = document.querySelector(`meta[name="${metaName}"]`);
              if (metaTag) {
                  // Update existing meta tag
                  metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
              } else {
                  // Create new meta tag if it doesn't exist
                  const newMetaTag = document.createElement('meta');
                  newMetaTag.name = metaName;
                  newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                  document.head.appendChild(newMetaTag);
              }
          });
    
          // Cleanup function to reset the title and meta tags when unmounting
          return () => {
              document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
              Object.keys(metaTags).forEach((metaName) => {
                  const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                  if (metaTag) {
                      metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                  }
              });
          };
      } catch (error) {
          //console.error("Error updating title and meta tags:", error);
      }
    };
    return (
      <div>
        <Header />
        <main className="main-content-shipment-policy container">
        <div className="section_breadcrumb">
        <div className="container-">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a >Shipping Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
          <div className="tnc-page-shipment">
            <h2>Shipping Policy</h2>
            <div className="tnc-items">
              <ol className="order-list" type="1">
                <li>
                  <span className="ship-subheading-list">
                    WHAT IS SELSMART?
                  </span>
                  <br />
                  <p className="user-account-content-shipment">
                    Attero Recycling Private Limited, a company incorporated
                    under the laws of India, having its registered office at 2,
                    C/o Saraswati Press, Green Park, Dehradun 248001,
                    Uttarakhand, India and corporate office at A-72/A,
                    Sector-64, Noida 201301, Uttar Pradesh, India (“Selsmart”,
                    “We”, “Our”, “Us”) understand that, selling used electronic
                    or electrical products (“Products”) can be a hassle, which
                    is why through www.selsmart.in (“Website”), We provide Our
                    users (“You”, “Your”, “Yours”) an online platform to sell
                    their Products, conveniently and effortlessly from the
                    comfort of their home or office.<strong>What is Selsmart Shipping Policy?
                  </strong><p className="user-account-content-shipment">
                    This Shipping Policy (“Policy”), together read with Terms
                    and Conditions and Privacy Policy, describes Our policies
                    and procedures towards collection of Products sold to Us
                    through Our Website. We make commercially reasonable
                    endeavours to ensure that the Products are collected from
                    You in a timely manner.
                    <br />
                    We request You to read and understand the terms of this
                    Policy. If You do not agree to the terms contained in this
                    Policy, You shall not avail Our services. By availing Our
                    services, You acknowledge and agree to be bound by this
                    Policy.
                  </p></p>

                  
                  
                </li>
                <li>
                  <span className="ship-subheading-list">
                    TERMS OF COLLECTIONS
                  </span>
                  <br />
                  <p className="user-account-content-shipment">
                    We have a dedicated in-house logistics team as well as third
                    party logistics service provider to facilitate safe and
                    secure collection of Your Products from Your requested
                    location. We ensure that Our and Our third-party logistics
                    service provider’s Product collection executives are
                    individuals with highest regard for ethics and integrity.
                    However, it is not possible for Us to ensure that logistics
                    service provider’s Product collection executives will behave
                    consistently demonstrate professionalism, competence, and
                    good manners. We hereby clarify that any ill-mannerism,
                    impoliteness, discourtesy, or offensiveness shown by
                    logistics service provider’s Product collection executives
                    is beyond Our control and any issue arising between You and
                    Our logistics service provider’s Product collection
                    executive will have to be resolved by You independently.
                    <br />
                    Once the sale of the Products is finalized, We will provide
                    You the contract information and pick up details of Our
                    logistics service provider Product collection executive. You
                    will have the flexibility to choose a convenient time slot
                    for the pickup within their operational hours. We request
                    You to be present during the pickup to answer any questions
                    the Product collection executive may have about the
                    Product’s condition.
                    <br />A maximum of one attempt shall be made to collect the
                    Products from You. If You continue to remain unavailable
                    after one attempt, We reserve the right to cancel the
                    collection of Products at Our sole discretion.
                  </p>
                </li>
                <li>
                  <span className="ship-subheading-list">SHIPMENT CHARGES</span>
                  <br />
                  <p className="user-account-content-shipment">
                    We may charge fee for collection of Products for Your
                    convenience. This fee will be clearly communicated to You
                    before You finalize the sale.
                  </p>
                </li>

                <li>
                  <span className="ship-subheading-list">AVAILABILITY</span>
                  <br />
                  <p className="user-account-content-shipment">
                    We aim to provide Our services across India, however
                    currently We are rendering Our services only in selective
                    locations. We request You to kindly check Our service
                    availability by providing Us Your location Pin Code before
                    placing an order.
                  </p>
                </li>
                <li>
                  <span className="ship-subheading-list">OTHER CONDITIONS</span>
                  <br />
                  <p className="user-account-content-shipment">
                    We reserve the right, at any time and without prior notice
                    to You, to update, revise, or alter this Policy. Any such
                    revision, correction, or modification will become effective
                    as soon as it is published on the website.
                  </p>
                </li>

                <li>
                  <span className="ship-subheading-list">CONTACT US</span>
                  <br />
                  <p className="user-account-content-shipment">
                    In the event of any complaint relating to any terms of this
                    Policy or delay of the Product collection, please contact us
                    through email at: {' '}
                     <a href="mailto:care@selsmart.in">care@selsmart.in</a>
                    <br />
                  </p>
                  <p className="user-account-content-shipment">
                    We will promptly respond to Your queries or complaints and
                    will endeavour to resolve them as soon as possible.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
};

export default ShipmentPolicyPage;
